var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": function ($event) {
              _vm.tableData = []
              _vm.searchAct()
            },
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "线上数据", name: "1" } }),
          _c("el-tab-pane", { attrs: { label: "本地数据", name: "0" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                clearable: "",
                size: "small",
                placeholder: "选择商品名称",
              },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.productId,
                callback: function ($$v) {
                  _vm.productId = $$v
                },
                expression: "productId",
              },
            },
            _vm._l(_vm.productList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              attrs: { size: "small", clearable: "", placeholder: "销售渠道" },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.isIOS,
                callback: function ($$v) {
                  _vm.isIOS = $$v
                },
                expression: "isIOS",
              },
            },
            [
              _c("el-option", { attrs: { label: "非IOS内购", value: 0 } }),
              _c("el-option", { attrs: { label: "IOS内购", value: 1 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: { size: "small", clearable: "", placeholder: "优惠状态" },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.discountStatus,
                callback: function ($$v) {
                  _vm.discountStatus = $$v
                },
                expression: "discountStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "生效", value: 1 } }),
              _c("el-option", { attrs: { label: "失效", value: 2 } }),
            ],
            1
          ),
          _vm.activeName == "0"
            ? _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "审核状态",
                  },
                  on: { change: _vm.searchAct },
                  model: {
                    value: _vm.checkStatus,
                    callback: function ($$v) {
                      _vm.checkStatus = $$v
                    },
                    expression: "checkStatus",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "草稿", value: 0 } }),
                  _c("el-option", { attrs: { label: "待审核", value: 1 } }),
                  _c("el-option", { attrs: { label: "通过", value: 2 } }),
                  _c("el-option", { attrs: { label: "不通过", value: 3 } }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.searchAct },
            },
            [_vm._v("搜索")]
          ),
          _vm.activeName == "0"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberDiscount_add",
                      expression: "'memberDiscount_add'",
                    },
                  ],
                  attrs: {
                    icon: "el-icon-plus",
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.openEdit },
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.activeName,
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "", label: "ID", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.activeName == "0"
                          ? scope.row.originalId
                          : scope.row.id
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "productName", label: "商品名称", width: "200" },
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "优惠标签" } }),
          _c("el-table-column", {
            attrs: { prop: "originalPrice", label: "原价（元）", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { label: "销售渠道", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.isIOS == 1
                            ? "IOS内购"
                            : scope.row.isIOS == 0
                            ? "非IOS内购 "
                            : ""
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "price", label: "优惠价（元）", width: "110" },
          }),
          _c("el-table-column", {
            attrs: { label: "优惠状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.status == 1
                          ? "生效"
                          : scope.row.status == 2
                          ? "失效"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activeName == "0"
            ? _c("el-table-column", {
                attrs: { label: "审核状态" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm._f("reviewStatus")(scope.row.reviewStatus)
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  811752964
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "remark",
              label: "备注",
            },
          }),
          _vm.activeName == "0"
            ? _c("el-table-column", {
                attrs: { fixed: "right", width: "250", label: "操作" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.reviewStatus == 0 ||
                          scope.row.reviewStatus == 4
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberDiscount_submitCheck",
                                      expression:
                                        "'memberDiscount_submitCheck'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitCheck(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("提交审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberDiscount_check",
                                      expression: "'memberDiscount_check'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCheck(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberDiscount_cancelCheck",
                                      expression:
                                        "'memberDiscount_cancelCheck'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeCheck(scope.row, 4)
                                    },
                                  },
                                },
                                [_vm._v("撤销审核")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "memberDiscount_viewLog",
                                  expression: "'memberDiscount_viewLog'",
                                },
                              ],
                              attrs: {
                                icon: "el-icon-view",
                                size: "mini",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openLog(scope.row)
                                },
                              },
                            },
                            [_vm._v("查看日志")]
                          ),
                          _vm.activeName == "0" && scope.row.reviewStatus != 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberDiscount_change",
                                      expression: "'memberDiscount_change'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-edit",
                                    size: "small",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberDiscount_delete",
                                      expression: "'memberDiscount_delete'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-delete",
                                    size: "small",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delDiscount(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  536900636
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalEl,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核活动",
            visible: _vm.showCheck,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCheck = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-width": "110px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商品名称" } }, [
                _vm._v(_vm._s(_vm.checkItem.productName)),
              ]),
              _c("el-form-item", { attrs: { label: "原价" } }, [
                _vm._v(_vm._s(_vm.checkItem.originalPrice) + "元"),
              ]),
              _c("el-form-item", { attrs: { label: "优惠价" } }, [
                _vm._v(_vm._s(_vm.checkItem.price) + "元"),
              ]),
              _c("el-form-item", { attrs: { label: "优惠状态" } }, [
                _vm._v(
                  _vm._s(
                    _vm.checkItem.status == 1
                      ? "生效"
                      : _vm.checkItem.status == 2
                      ? "失效"
                      : ""
                  )
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "审核意见" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: 150,
                      resize: "none",
                      placeholder: "请输入审核意见",
                    },
                    model: {
                      value: _vm.checkMark,
                      callback: function ($$v) {
                        _vm.checkMark = $$v
                      },
                      expression: "checkMark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberDiscount_check",
                      expression: "'memberDiscount_check'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeCheck(_vm.checkItem, 2)
                    },
                  },
                },
                [_vm._v("通过审核")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberDiscount_check",
                      expression: "'memberDiscount_check'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "danger",
                    icon: "el-icon-circle-close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeCheck(_vm.checkItem, 3)
                    },
                  },
                },
                [_vm._v("拒绝审核")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showCheck = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作日志",
            visible: _vm.showLog,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showLog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { "max-height": 400, border: "", data: _vm.logData } },
            [
              _c("el-table-column", {
                attrs: { prop: "applyUserName", label: "申请人" },
              }),
              _c("el-table-column", {
                attrs: { prop: "applyTime", label: "申请时间", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "operationType", label: "操作类型" },
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewUserName", label: "审核人" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reviewContent",
                  "show-overflow-tooltip": "",
                  label: "审核内容",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewTime", label: "审核时间", width: "180" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showLog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.checkItem.id ? "修改活动" : "创建商品折扣",
            visible: _vm.showEdit,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showEdit = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.checkItem,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "productId" } },
                [
                  _vm.checkItem.id
                    ? _c("p", { staticStyle: { margin: "0" } }, [
                        _vm._v(_vm._s(_vm.checkItem.productName)),
                      ])
                    : _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            size: "small",
                            placeholder: "选择商品名称",
                          },
                          model: {
                            value: _vm.checkItem.productId,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "productId", $$v)
                            },
                            expression: "checkItem.productId",
                          },
                        },
                        _vm._l(_vm.productList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "原价" } }, [
                _vm._v(
                  _vm._s(_vm.originPrice || _vm.checkItem.originalPrice) + "元"
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "优惠价", prop: "price" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      size: "small",
                      precision: 2,
                      step: 0.1,
                      min: 0.01,
                      max: _vm.originPrice || _vm.checkItem.originalPrice,
                    },
                    model: {
                      value: _vm.checkItem.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.checkItem, "price", $$v)
                      },
                      expression: "checkItem.price",
                    },
                  }),
                  _vm._v(" 元\n      "),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "优惠标签" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: 4,
                      size: "small",
                      placeholder: "最多可输入4个中文字符",
                    },
                    model: {
                      value: _vm.checkItem.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.checkItem, "name", $$v)
                      },
                      expression: "checkItem.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "优惠状态" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.checkItem.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkItem, "status", $$v)
                        },
                        expression: "checkItem.status",
                      },
                    },
                    [_vm._v("生效")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 2 },
                      model: {
                        value: _vm.checkItem.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkItem, "status", $$v)
                        },
                        expression: "checkItem.status",
                      },
                    },
                    [_vm._v("失效")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: 150,
                      resize: "none",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.checkItem.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.checkItem, "remark", $$v)
                      },
                      expression: "checkItem.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberDiscount_change",
                      expression: "'memberDiscount_change'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.saveEdit("ruleForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showEdit = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }